import { format } from "date-fns";

export function getDate(date) {
    return !date || date === "" ? "NA" : format(new Date(date), "dd/MM/yyyy");
}

export function getDateTime(date) {
    return !date || date === "" ? "NA" : format(new Date(date), "dd/MM/yyyy hh:mm:ss aaaa");
}

export function getDatePost(date) {
    return !date || date === "" ? null : format(new Date(date), "yyyy-MM-dd");
}
export function getDateTimePost(date) {
    return !date || date === "" ? null : format(new Date(date), "yyyy-MM-ddThh:mm:ss");
}
